import { GridColDef } from '@mui/x-data-grid';
import { SubjectResponse } from '../types';
import { Box, IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';

export const getViewEditExamModalColumns = (
  setSubjectToEdit: (subject: SubjectResponse) => void,
  handleDeleteSubjectModalOpen: (id: string) => void,
  setIsEditSubjectModalOpen: (isOpen: boolean) => void
): GridColDef[] => [
  {
    field: 'subjectName',
    headerName: 'Subject',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'scoringType',
    headerName: 'Scoring Type',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'maxMarks',
    headerName: 'Max Marks',
    width: 110,
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    type: 'number'
  },
  {
    field: 'gradeScale',
    headerName: 'Grade Scale',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    filterable: false,
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    renderCell: (params) => (
      <Box>
        <Tooltip title='Edit'>
          <IconButton
            size='small'
            onClick={() => {
              setSubjectToEdit((params.row as any).raw);
              setIsEditSubjectModalOpen(true);
            }}
          >
            <Icons.EditBlackOutlined />
          </IconButton>
        </Tooltip>
        <Tooltip title='Delete'>
          <IconButton
            size='small'
            onClick={() => {
              handleDeleteSubjectModalOpen((params.row as any).raw.subject.id);
            }}
          >
            <Icons.Delete width={20} height={20} />
          </IconButton>
        </Tooltip>
      </Box>
    )
  }
];
